'use strict';

module.exports = {
    initScrollToTopButton: function () {
        let lastScrollTop = 0;

        $(window).on('scroll', function () {
            let currentScroll = $(this).scrollTop();

            if (currentScroll < lastScrollTop && currentScroll > 200) {
                $('#scrollToTopButton').fadeIn();
            } else {
                $('#scrollToTopButton').fadeOut();
            }

            lastScrollTop = currentScroll;
        });

        $('#scrollToTopButton').on('click', function () {
            $('html, body').animate({ scrollTop: 0 }, 'slow');
        });
    }
};
